import React from "react";
import { RangeSliderProps } from "./RangeSlider.types";
import {
  Container,
  CustomSlider,
  Title,
  useStyles,
} from "./RangeSlider.styles";

export const RangeSlider: React.FC<RangeSliderProps> = ({
  min,
  max,
  onFilterChanged,
  title,
  id,
}) => {
  const classes = useStyles();
  const [value, setValue] = React.useState<number[]>([min, max]);

  const handleChange = (event: any, newValue: number | number[]) => {
    setValue(newValue as number[]);
    onFilterChanged(id, newValue);
  };

  return (
    <Container>
      <code className={classes.root}>
        <Title>{title}</Title>
        <CustomSlider
          value={value}
          onChange={handleChange}
          valueLabelDisplay="on"
          valueLabelFormat={value => <span>{value.toLocaleString()}</span>}
          min={min}
          max={max}
        />
      </code>
    </Container>
  );
};
